export const LOADER_SET_PAGE_LOADER_ACTIVE = 'LOADER_SET_PAGE_LOADER_ACTIVE';
export const LOADER_MODAL_SET_OPEN = 'LOADER_MODAL_SET_OPEN';
export const LOADER_SET_COMPONENT_LOADER_ACTIVE = 'LOADER_SET_COMPONENT_LOADER_ACTIVE';
